"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpMethod;
(function (HttpMethod) {
    HttpMethod[HttpMethod["GET"] = 0] = "GET";
    HttpMethod[HttpMethod["PUT"] = 1] = "PUT";
    HttpMethod[HttpMethod["POST"] = 2] = "POST";
    HttpMethod[HttpMethod["DELETE"] = 3] = "DELETE";
})(HttpMethod || (HttpMethod = {}));
exports.HttpMethod = HttpMethod;
var HttpMethodString = function (method) {
    switch (method) {
        case HttpMethod.GET:
            return 'GET';
        case HttpMethod.PUT:
            return 'PUT';
        case HttpMethod.POST:
            return 'POST';
        case HttpMethod.DELETE:
            return 'DELETE';
        default:
            throw 'HttpMethod has no string representation';
    }
};
var ResponseResolver = /** @class */ (function () {
    function ResponseResolver() {
    }
    /*
     * Method does not detect circular references so use with care!
     */
    ResponseResolver.PascalToCamelResolver = function () {
        var _this = this;
        return function (source) {
            var keys = Object.keys(source);
            var lowercaseFirstChar = function (v) {
                return v.charAt(0).toLowerCase() + v.slice(1);
            };
            var newObj = {};
            for (var key in keys) {
                if (source.hasOwnProperty(keys[key])) {
                    var keyName = keys[key];
                    var camelcaseKeyName = lowercaseFirstChar(keyName);
                    newObj[camelcaseKeyName] = source[keyName];
                    if (newObj[camelcaseKeyName] instanceof Object) {
                        newObj[camelcaseKeyName] = _this.PascalToCamelResolver()(newObj[camelcaseKeyName]);
                    }
                }
            }
            return newObj;
        };
    };
    return ResponseResolver;
}());
exports.ResponseResolver = ResponseResolver;
var HttpRequestUtility = /** @class */ (function () {
    function HttpRequestUtility() {
    }
    HttpRequestUtility.Delete = function (url, body) {
        var request = this.CreateRequest(url, HttpMethod.DELETE, body);
        return this.ExecuteJsonRequest(request);
    };
    HttpRequestUtility.Get = function (url) {
        var request = this.CreateRequest(url, HttpMethod.GET);
        return this.ExecuteJsonRequest(request);
    };
    HttpRequestUtility.Post = function (url, body) {
        var request = this.CreateRequest(url, HttpMethod.POST, body);
        return this.ExecuteJsonRequest(request);
    };
    HttpRequestUtility.Put = function (url, 
    // tslint:disable-next-line:no-any
    body) {
        var request = this.CreateRequest(url, HttpMethod.PUT, body);
        return this.ExecuteJsonRequest(request);
    };
    HttpRequestUtility.CreateRequest = function (url, method, body) {
        var methodString = HttpMethodString(method);
        var requestInit = {
            method: methodString,
            headers: [
                ['Content-Type', 'application/json'],
                ['Accept', 'application/json'],
            ]
        };
        if (body !== undefined) {
            requestInit.body = JSON.stringify(body);
        }
        return new Request(url, requestInit);
    };
    /*
    * Will automatically attempt to parse response json to the requested type, in case of casing/naming mismatch,
    * a custom resolver can be provided to handle mapping from the raw json response object (note: it is not json, it
    * is an object of type any with properties corresponding to the json property names)
    */
    HttpRequestUtility.ExecuteJsonRequest = function (request, responseResolver) {
        var _this = this;
        var webCall = fetch(request);
        var responsePromise = new Promise(function (resolve, reject) {
            var okFetch = _this.okWebCallPromise(webCall);
            okFetch.catch(reject);
            var jsonPromise = okFetch.then(function (response) {
                return response.json().catch(function (error) {
                    return null;
                });
            });
            jsonPromise.then(function (obj) {
                if (responseResolver !== undefined) {
                    var resolved = responseResolver(obj);
                    resolve(resolved);
                }
                else {
                    resolve(obj);
                }
            }).catch(reject);
        });
        return responsePromise;
    };
    HttpRequestUtility.okWebCallPromise = function (webCall) {
        return new Promise(function (resolve, reject) {
            webCall.then(function (res) {
                if (res.ok === false) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    return HttpRequestUtility;
}());
exports.HttpRequestUtility = HttpRequestUtility;
exports.default = HttpRequestUtility;
//# sourceMappingURL=HttpRequestUtil.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chorus/json-request-library/build/lib/lib/HttpRequestUtil.js
// module id = 73
// module chunks = 0 1 2 3